import { gql } from '@apollo/client';

export default gql`
  mutation updateBookingSegments($currency: String!, $bookingReference: String!, $segments: [InputSegment]) {
    updateBookingSegments(currency: $currency, bookingReference: $bookingReference, segments: $segments) {
      reference
    }
  }
`;
